import useUnitText from "@/wl-unit-text/useUnitText";
import store from "@/store";

export default {
    install: (Vue, options) => {
        Vue.prototype.$unitText = (value) => {
            const {defaultKeyword, replaceText} = useUnitText();
            let type = store.getters['userDetails'].UnitType || 'lifts'
            if (type === defaultKeyword) return value;
            return replaceText(value, type)
        }
        Vue.prototype.$unitIcon = (value) => {
            const {replaceIcon} = useUnitText();
            let type = store.getters['userDetails'].UnitType || 'lifts'
            return replaceIcon(value, type)
        }
    }
}